// returns true if string contains ONLY letters and/or numbers
export default function alphanumeric(str) {
  const letterNumber = /^[0-9a-zA-Z]+$/
  if (str.match(letterNumber)) {
    return true
  } else {
    return false
  }
}
